<template>
  <form>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ school_id ? 'Update' : 'Create' }} School</p>
      </header>
      <div class="modal-card-body">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

        <b-field label="Name">
          <b-input
            ref="title"
            v-model="school.name"
            minlength="2"
            required
            type="text"
            placeholder="School name"
          ></b-input>
        </b-field>

        <b-field label="Remarks">
          <b-input
            v-model="school.remarks"
            type="textarea"
            placeholder="Any remarks"
          ></b-input>
        </b-field>

        <b-field label="Status">
          <b-switch v-model="school.status" type="is-success">
            {{ school.status ? 'Active' : 'Inactive' }}
          </b-switch>
        </b-field>

        <button
          type="button"
          @click.prevent="proceed()"
          class="button is-success btn-center"
        >{{ school_id ? 'Update' : 'Create' }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'set-school',
  props: {
    school_id: { type: String, default: null }
  },
  data(){
    return {
      isLoading : false,
      school : {
        name : '',
        remarks : '',
        status : true
      }
    }
  },
  computed : {
    ...mapGetters(['getTeacherToken', 'fetchSchools'])
  },
  methods : {
    ...mapActions(['createSchool', 'updateSchool', 'loadSchoolById']),
    proceed(){
      const valid = this.$refs.title.checkHtml5Validity()
      if(!valid) return

      this.isLoading = true
      const action = this.school_id
        ? this.updateSchool({ id: this.school_id, school: this.school, token: this.getTeacherToken })
        : this.createSchool({ school: this.school, token: this.getTeacherToken })

      action
        .then(() => {
          this.isLoading = false
          this.$emit('over')
          this.$buefy.toast.open({
            message: `School ${this.school_id ? 'updated' : 'created'} successfully`,
            type: 'is-success'
          })
        })
        .catch(err => {
          this.isLoading = false
          this.$buefy.toast.open({
            message: (err.response && err.response.data && err.response.data.msg) || 'Something went wrong',
            type: 'is-danger'
          })
        })
    }
  },
  async created(){
    if(this.school_id){
      this.isLoading = true
      try{
        const existing = (this.fetchSchools || []).find(s => s._id == this.school_id)
        if(existing){
          this.school.name = existing.name || ''
          this.school.remarks = existing.remarks || ''
          this.school.status = existing.status !== false
        }else{
          await this.loadSchoolById({ id: this.school_id, token: this.getTeacherToken })
        }
      }catch(_e){ /* ignore */ }
      this.isLoading = false
    }
  }
}
</script>
